module.exports = __webpack_public_path__ + "static/img/3-1-1.6cc53511.png";